import { NgModule } from '@angular/core';

import { IqDashboardComponent } from './pages/iq-dashboard/iq-dashboard.component';

@NgModule({
  imports: [IqDashboardComponent],
  exports: [IqDashboardComponent],
})
export class IqAggregatedDashboardModule {}
